export const GALLERY_WIDTH = 117
